import BackgroundFileResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFileResponse";

import { findPreferredTranslation } from "@/utils/languagePriority";

export default class BackgroundFileViewModel {
    id: string;
    name: string;
    constructor(obj?: BackgroundFileResponse) {
        if (obj != null) {
            this.id = obj.Id;
            const translation = findPreferredTranslation(
                obj.Translations || [],
                (item: any) => Boolean(item && item.Name)
            );
            this.name = translation ? translation.Name : '';
        }
    }
}
